import Axios from 'axios';

export const HTTP_CONFIG = {
  BACKOFFICE_V2: 'V2',
  backOfficeVersion:
    process.env.VUE_APP_API_BACKOFFICE_VERSION === undefined ? 'V1' : 'V2',
};

export const HTTP_API = {
  hasSuccessStatus(status) {
    return status === 'success' || status === 'ok';
  },
  getContent(response) {
    if (response.content !== undefined) {
      return response.content;
    }
    if (response.data !== undefined) {
      return response.data;
    }
    return response;
  },
};

export const HTTP = Axios.create({
  baseURL: `${process.env.VUE_APP_API_LOCATION}`,
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

HTTP.interceptors.request.use((config) => {
  const data = Object.keys(config.data).reduce((acc, key) => {
    if (config.data[key]) acc[key] = config.data[key];
    return acc;
  }, {});
  return { ...config, data };
});

export const HTTP_GRAYLOG = Axios.create({
  baseURL: `${process.env.VUE_APP_GRAYLOG_API_LOCATION}`,
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export const GRAYLOG_CONFIG = Axios.create({
  baseURL: '/',
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export function getRuntimeConfig() {
  return GRAYLOG_CONFIG.get('/config/runtime.json').then(
    response => response.data,
  );
}
